export class SYS102Params {
   /** 主要文字顏色 */
   FontColor: string;
   /** 提示文字顏色 */
   FontTipColor: string;
   /** 表格標頭列底色 */
   GridHeaderColor: string;
   /** 表格分頁行底色 */
   GridPaginatorColor: string;
   /** 表格單數行底色 */
   GridRowOdd: string;
   /** 表格雙數行底色 */
   GridRowEven: string;
   /** 表格資料行選取顏色 */
   GridRowSelected: string;
   /** 表格資料行滑鼠路過顏色 */
   GridRowHover: string;
   /** 表單標頭底色 */
   CardHeaderColor: string;
   /** 主顏色 */
   MainColor: string;
   /** 頂部區域文字顏色 */
   MainColorFont:string;
   /** 按鈕0底色 */
   Button0Color: string;
   /** 按鈕0文字顏色 */
   Button0FontColor: string;
   /** 按鈕0底色(游標在上) */
   Button0HoverColor: string;
   /** 按鈕0文字顏色(游標在上) */
   Button0HoverFontColor: string;
   /** 按鈕1底色 */
   Button1Color: string;
   /** 按鈕1文字顏色 */
   Button1FontColor: string;
   /** 按鈕1底色(游標在上) */
   Button1HoverColor: string;
   /** 按鈕1文字顏色(游標在上) */
   Button1HoverFontColor: string;
   /** 按鈕2底色 */
   Button2Color: string;
   /** 按鈕2文字顏色 */
   Button2FontColor: string;
   /** 按鈕2底色(游標在上) */
   Button2HoverColor: string;
   /** 按鈕2文字顏色(游標在上) */
   Button2HoverFontColor: string;
   /** 按鈕3底色 */
   Button3Color: string;
   /** 按鈕3文字顏色 */
   Button3FontColor: string;
   /** 按鈕3底色(游標在上) */
   Button3HoverColor: string;
   /** 按鈕3文字顏色(游標在上) */
   Button3HoverFontColor: string;
   /** 開關按鈕顏色(選取時) */
   ToggleColor: string;
   /** 掛號漸層色1 */
   RegBgColor1: string;
   /** 掛號漸層色2 */
   RegBgColor2: string;
   /** 掛號漸層色3 */
   RegBgColor3: string;
   /** 重點文字顏色 */
   FontColorHighlight: string;
   /** 警告文字顏色 */
   FontColorAlert: string;
   /** 提醒文字顏色 */
   FontColorWarning: string;
   /** 標籤1顏色(啟動) */
   TabActiveColor1: string;
   /** 標籤1顏色(背景) */
   TabColor1: string;
   /** 標籤1文字顏色 */
   TabFontColor1: string;
   /** 標籤2顏色(啟動) */
   TabActiveColor2: string;
   /** 標籤2顏色(背景) */
   TabColor2: string;
   /** 標籤2文字顏色 */
   TabFontColor2: string;
   /** 掛號身理量測底色 */
   VtColor1: string;
   /** 掛號身理量測底色(偶數) */
   VtColor2: string;
   /** 彈出框的底色(警告/確認/下拉選單) */
  DialogBg: string;
  /** 門診每一區塊的標題底色 */
  HistPanelTitleBg: string;
  /** 門診每一區塊的標題文字顏色 */
  HistPanelTitleFont: string;
  /** 門診每一區塊的標題按鈕底色 */
  HistPanelTitleBtn: string;
  /** 門診病歷的標題底色 */
  HistCardTitle: string;
  /** 門診病歷的標題文字顏色 */
  HistCardTitleFont: string;
  /** 門診病歷醫令的底色 */
  HistViewGridBg: string;
  /** 門診病歷醫令單數行的底色 */
  HistViewGridBgOdd: string;
  /** 門診病歷醫令選取項的底色 */
  HistViewGridBgSelected: string;
  /** 門診輔助盤滑鼠一上去的底色 */
  HistPadHover: string;
  /** 門診輔助盤滑鼠一上去的文字顏色 */
  HistPadHoverFont: string;
  /** 門診焦點項目的底色 */
  HistAreaFocusBg: string;
  /** 門診焦點項目的文字顏色 */
  HistAreaFocusFont: string;
  /** 門診編輯區塊的底色 */
  HistAreaBg: string;
  /** 門診編輯區塊的文字顏色 */
  HistAreaFont: string;
  /** 門診編輯區塊停用的底色 */
  HistAreaDisableBg: string;
  /** 門診編輯區塊停用的文字顏色 */
  HistAreaDisableFont: string;
  /** 門診醫令區編輯中的底色 */
  HistTableCellBg: string;
  /** 門診醫令區編輯中的文字顏色 */
  HistTableCellFont: string;
  /** 門診醫令區每行底色 */
  HistTableRowBg: string;
  /** 門診醫令區每行底色(自費頁(中醫)) */
  HistTableRowBgSelfPay:string;
  /** 門診醫令區每行文字顏色 */
  HistTableRowFont: string;
  /** 門診醫令區標頭的底色 */
  HistTableHeaderBg: string;
  /** 門診醫令區標頭的文字顏色 */
  HistTableHeaderFont: string;
  /** 門診選盤的底色 */
  HistHelperBg: string;
   /** 門診完診相關按鈕的底色 */
  HistFinishBtnBg: string;
  /** 門診完診相關按鈕的文字顏色 */
  HistFinishBtnFont: string;
  /** 門診完診相關按鈕的游標放置時底色 */
  HistFinishBtnHoverBg: string;
  /** 門診完診相關按鈕的游標放置時文字顏色 */
  HistFinishBtnHoverFont: string;
  /** 開關文字顏色 */
  ToggleFontColor: string;
  /** 文字顏色(停用時) */
  FontColorDisabled: string;
  /** 表單底色 */
  CardBg: string;
  /** 必填輸入框底色 */
  InputRequired: string;  
  /** 輸入框底色 */
  InputBg: string;  

  /**診間顯示時間種類 0 */
  DisplayTimeType :string;
}

/** SYS102 參數 → CSS 變數對照：啟動時寫入 :root（start-up-service.updateUIColor），表單模式的顏色風格示意圖也用它讀取 styles.scss 預設色 */
export const SYS102_CSS_VARS: Partial<Record<keyof SYS102Params, string>> = {
  FontColor: '--font-color',
  FontTipColor: '--font-color-tip',
  GridHeaderColor: '--vis-grid-header-color',
  GridPaginatorColor: '--grid-paginator',
  GridRowOdd: '--grid-odd',
  GridRowEven: '--grid-even',
  GridRowSelected: '--grid-selected',
  GridRowHover: '--grid-hover',
  CardHeaderColor: '--vis-card-header-color',
  MainColor: '--main-color',
  MainColorFont: '--main-color-font',
  // 基本按鈕
  Button0Color: '--vis-btn-bg',
  Button0FontColor: '--vis-btn-font',
  Button0HoverColor: '--vis-btn-bg-hover',
  Button0HoverFontColor: '--vis-btn-font-hover',
  // 按鈕1
  Button1Color: '--vis-btn-primary-color',
  Button1FontColor: '--vis-btn-primary-font-color',
  Button1HoverColor: '--vis-btn-primary-hover-color',
  Button1HoverFontColor: '--vis-btn-primary-hover-font-color',
  // 按鈕2
  Button2Color: '--vis-btn-secondary-color',
  Button2FontColor: '--vis-btn-secondary-font-color',
  Button2HoverColor: '--vis-btn-secondary-hover-color',
  Button2HoverFontColor: '--vis-btn-secondary-hover-font-color',
  // 按鈕3
  Button3Color: '--vis-btn-third-color',
  Button3FontColor: '--vis-btn-third-font-color',
  Button3HoverColor: '--vis-btn-third-hover-color',
  Button3HoverFontColor: '--vis-btn-third-hover-font-color',
  // 掛號
  RegBgColor1: '--vis-reg-bg-color1',
  RegBgColor2: '--vis-reg-bg-color2',
  RegBgColor3: '--vis-reg-bg-color3',
  VtColor1: '--vis-reg-vt-color1',
  VtColor2: '--vis-reg-vt-color2',
  // 警示文字
  FontColorHighlight: '--vis-font-highlight',
  FontColorAlert: '--vis-font-alert',
  FontColorWarning: '--vis-font-warning',
  // 開關
  ToggleColor: '--vis-toggle-active',
  // 頁籤1
  TabActiveColor1: '--vis-tab-primary-active',
  TabColor1: '--vis-tab-primary-inactive',
  TabFontColor1: '--vis-tab-primary-font-color',
  // 頁籤2
  TabActiveColor2: '--vis-tab-second-active',
  TabColor2: '--vis-tab-second-inactive',
  TabFontColor2: '--vis-tab-second-font-color',
  DialogBg: '--vis-dialog-bg',
  // 門診
  // 主色系 (側邊攔)
  HistPanelTitleBg: '--vis-hist-main',
  HistPanelTitleFont: '--vis-hist-main-font',
  HistPanelTitleBtn: '--vis-hist-main-btn',
  // 各區標頭
  HistCardTitle: '--vis-hist-card-title-bg',
  HistCardTitleFont: '--vis-hist-card-title-font',
  HistViewGridBg: '--vis-history-bg-color',
  HistViewGridBgOdd: '--vis-history-bg-color-odd',
  HistViewGridBgSelected: '--vis-history-bg-color-selected',
  // 配盤項目游標放上去
  HistPadHover: '--vis-hist-pad-hover',
  HistPadHoverFont: '--vis-hist-pad-font-hover',
  // 門診TextArea focus顏色
  HistAreaFocusBg: '--vis-hist-input-focus-bg',
  HistAreaFocusFont: '--vis-hist-input-focus-font',
  HistAreaBg: '--vis-hist-input-bg',
  HistAreaFont: '--vis-hist-input-font',
  // 診斷名稱
  HistAreaDisableBg: '--vis-hist-input-disable-bg',
  HistAreaDisableFont: '--vis-hist-input-disable-font',
  // 醫令區
  HistTableCellBg: '--vis-hist-cell-input-bg',
  HistTableCellFont: '--vis-hist-cell-input-font',
  HistTableRowBg: '--vis-hist-order-row-bg',
  HistTableRowBgSelfPay: '--vis-hist-order-row-bg-selfpay',
  HistTableRowFont: '--vis-hist-order-row-bg-even',
  HistTableHeaderBg: '--vis-hist-order-header-bg',
  HistTableHeaderFont: '--vis-hist-order-header-font',
  // 輔助盤
  HistHelperBg: '--vis-hist-helper-bg',
  // 完診按鈕
  HistFinishBtnBg: '--vis-hist-finish-color',
  HistFinishBtnFont: '--vis-hist-finish-font-color',
  HistFinishBtnHoverBg: '--vis-hist-finish-hover-color',
  HistFinishBtnHoverFont: '--vis-hist-finish-hover-font-color',
  ToggleFontColor: '--vis-toggle-active-font',
  FontColorDisabled: '--font-color-disabled',
  CardBg: '--vis-card-bg',
  // 必填input底
  InputRequired: '--vld-required-bg-color',
  InputBg: '--vld-input-bg-color'
};
